/* ==========================================================================
   Matcha Tasting Flight purchase options
   Markup: snippets/matcha-tasting-flight-2026.liquid (sizes, plan rows, tiers,
   ATC). Loaded deferred from that snippet; reads the default size from the
   wrapper's data-default-size.
   ========================================================================== */
(function() {
  'use strict';

  // per cart currency, matching sections/cart-drawer.liquid; other currencies get no bar
  const FREE_SHIPPING_THRESHOLDS = { CAD: 45, USD: 85 };
  // set by the snippet, which knows the section's default size
  const wrapper = document.querySelector('.matcha-subscription-wrapper');
  const DEFAULT_SIZE = wrapper ? wrapper.dataset.defaultSize : '';

  const CartHandler = {
    isProcessing: false,
    currentSize: DEFAULT_SIZE,

    init: function() {
      const button = document.getElementById('matchaAddToCart');
      if (!button) return;

      this.options = Array.from(document.querySelectorAll('.matcha-option'));
      this.lastTier = 'prepay-2';
      this.sizeButtons = Array.from(document.querySelectorAll('.matcha-size__btn'));
      this.backInStock = document.querySelector('back-in-stock');

      this.sizeButtons.forEach(btn => {
        btn.addEventListener('click', () => {
          this.selectSize(btn.dataset.size);
        });
      });
      // re-price atc and redraw the plan rows when the selection changes
      this.options.forEach(opt => {
        const radio = opt.querySelector('input[name="matcha_purchase"]');
        if (radio) radio.addEventListener('change', () => { this.renderPlans(); this.updateAtcPrice(); });
      });

      // The prepay head is not an input — clicking it selects a tier, defaulting to the
      // first and remembering whichever the shopper last chose.
      const prepayHead = document.querySelector('[data-plan-head]');
      if (prepayHead) {
        const choose = () => {
          const tiers = this.tierOptions();
          if (!tiers.length) return;
          const prev = tiers.find(o => o.dataset.tier === this.lastTier);
          const target = (prev && !prev.classList.contains('is-unavailable')) ? prev
            : (tiers.find(o => !o.classList.contains('is-unavailable')) || tiers[0]);
          const radio = target.querySelector('.matcha-radio');
          if (radio && !radio.disabled) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
        };
        prepayHead.addEventListener('click', choose);
        prepayHead.addEventListener('keydown', e => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(); }
        });
      }

      // remember the last prepay tier so reopening the row returns to it
      this.options.forEach(opt => {
        const radio = opt.querySelector('input[name="matcha_purchase"]');
        if (radio && (opt.dataset.tier || '').indexOf('prepay') === 0) {
          radio.addEventListener('change', () => { if (radio.checked) this.lastTier = opt.dataset.tier; });
        }
      });

      // default size: prefer the configured default, but fall back to the first
      // available size if the default is sold out
      const defBtn = this.sizeButtons.find(b => b.dataset.size === this.currentSize);
      if (defBtn && defBtn.dataset.soldout === 'true') {
        const firstAvail = this.sizeButtons.find(b => b.dataset.soldout !== 'true');
        if (firstAvail) this.currentSize = firstAvail.dataset.size;
      }
      this.selectSize(this.currentSize);
      const def = document.querySelector('input[name="matcha_purchase"][value="pay-per-flight"]')
               || document.querySelector('input[name="matcha_purchase"]');
      if (def) def.checked = true;
      this.renderPlans();
      this.updateAtcPrice();

      button.addEventListener('click', this.handleAddToCart.bind(this));
      this.setupModal();
      this.observeMainPrice();
      this.initShipBy();
    },

    // "Ships today/tomorrow/Monday" box, computed in Eastern time on the client
    // (never Liquid — it would cache stale). Cutoff: noon EST/EDT, Mon–Fri.
    initShipBy: function() {
      const self = this;
      const box = document.getElementById('matchaShipBy');
      const textEl = document.getElementById('matchaShipByText');
      if (!box || !textEl) return;

      function render() {
        // pre-order sizes (in stock ≤ 0 but "continue selling") ship on the restock
        // date, set in main-product → "Pre-order ship date"
        const curBtn = self.sizeButtons.find(b => b.dataset.size === self.currentSize);
        if (curBtn && curBtn.dataset.preorder === 'true') {
          // no date set: say nothing rather than promise one
          if (!box.dataset.preorderDate) { box.classList.add('mtf-soldout-hide'); return; }
          const strong = document.createElement('strong');
          strong.textContent = box.dataset.preorderDate;
          textEl.textContent = 'Ships out ';
          textEl.appendChild(strong);
          return;
        }
        // read "now" as Eastern wall-clock time (DST-aware via America/New_York)
        const et = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }));
        const day = et.getDay();               // 0 Sun … 6 Sat
        const h = et.getHours(), m = et.getMinutes(), s = et.getSeconds();
        let html;
        if (day === 0 || day === 6) {
          html = 'Ships <strong>Monday</strong>';
        } else if (h < 12) {
          // before noon → ships today, count down to the cutoff
          let rem = (12 * 3600) - (h * 3600 + m * 60 + s);
          if (rem < 0) rem = 0;
          const hh = Math.floor(rem / 3600);
          const mm = Math.floor((rem % 3600) / 60);
          const ss = rem % 60;
          const cd = hh >= 1
            ? (hh + 'h ' + mm + 'm')
            : (mm + 'm ' + (ss < 10 ? '0' : '') + ss + 's');
          html = 'Order within <strong>' + cd + '</strong> to ship today';
        } else {
          // after noon → next business day (Fri rolls to Monday)
          html = (day === 5) ? 'Ships <strong>Monday</strong>' : 'Ships <strong>tomorrow</strong>';
        }
        textEl.innerHTML = html;
      }

      render();
      this._shipByReady = true;
      this._renderShipBy = render;
      box.hidden = false;
      // only show the ship-by bar when the selected size is actually purchasable
      const curBtn = this.sizeButtons.find(b => b.dataset.size === this.currentSize);
      box.classList.toggle('mtf-soldout-hide', !(curBtn && curBtn.dataset.purchasable === 'true'));
      setInterval(render, 1000);
    },

    setupModal: function() {
      const openBtn = document.getElementById('matchaInfoOpen');
      const modal = document.getElementById('matchaInfoModal');
      if (!openBtn || !modal) return;
      const open = function() {
        // compensate for the scrollbar width so hiding overflow doesn't shift the page
        const sbw = window.innerWidth - document.documentElement.clientWidth;
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
        if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
        const c = modal.querySelector('.matcha-modal__close');
        if (c) c.focus();
      };
      const close = function() {
        modal.hidden = true;
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
        openBtn.focus();
      };
      openBtn.addEventListener('click', open);
      modal.querySelectorAll('[data-matcha-modal-close]').forEach(function(el) {
        el.addEventListener('click', close);
      });
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && !modal.hidden) close();
      });
    },

    parse: function(opt) {
      try { return JSON.parse(opt.dataset.variants || '{}'); } catch (e) { return {}; }
    },

    selectSize: function(size) {
      this.currentSize = size;
      this.sizeButtons.forEach(btn => {
        const on = btn.dataset.size === size;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      // update each tier's price + savings for the chosen size
      this.options.forEach(opt => {
        const data = this.parse(opt)[size];
        const priceEl = opt.querySelector('[data-price]');
        const saveEl = opt.querySelector('[data-savings]');
        const compareEl = opt.querySelector('[data-compare]');
        if (data) {
          if (priceEl) priceEl.textContent = data.price || '';
          if (saveEl) {
            if (data.savings) { saveEl.textContent = 'Save ' + data.savings; saveEl.hidden = false; }
            else { saveEl.textContent = ''; saveEl.hidden = true; }
          }
          if (compareEl) {
            if (data.compare) { compareEl.textContent = data.compare; compareEl.hidden = false; }
            else { compareEl.textContent = ''; compareEl.hidden = true; }
          }
          opt.classList.remove('is-unavailable');
        } else {
          // no variant for this size on this tier
          if (priceEl) priceEl.textContent = '—';
          if (saveEl) saveEl.hidden = true;
          if (compareEl) compareEl.hidden = true;
          opt.classList.add('is-unavailable');
        }
      });
      this.renderPlans();
      this.updateAtcPrice();
      this.updateBackInStock();
    },

    /* ---- plan rows -------------------------------------------------------
       The prepay row stands in for the prepay-* tiers, so its label, badge and
       price are read from whichever tier is selected (or the best-value one when
       the row is closed). Everything comes from the same data-variants JSON that
       already drives the per-tier prices — nothing new is hardcoded. */

    tierOptions: function() {
      return this.options.filter(o => (o.dataset.tier || '').indexOf('prepay') === 0);
    },

    perTin: function(data, flights) {
      // 3 tins per flight. Subscription tiers carry perflight; the one-time JSON does
      // not, so fall back to its total divided by the flight count.
      let n = parseFloat(String(data.perflight || '').replace(/[^0-9.]/g, ''));
      if (!isFinite(n) || !n) {
        const total = parseFloat(String(data.price || '').replace(/[^0-9.]/g, ''));
        const f = parseInt(flights, 10) || 1;
        n = isFinite(total) && total ? total / f : 0;
      }
      if (!n) return '';
      return '$' + (n / 3).toFixed(2) + this.per('tin');
    },

    // the gift part is its own span so a narrow box can drop it to a second line
    badgeHtml: function(saving, gift) {
      return saving.toUpperCase() + (gift ? '<span class="matcha-badge-gift">' + gift.toUpperCase() + '</span>' : '');
    },

    // "per" swaps to "/" in a narrow box (CSS), so the unit is marked up rather than plain text
    per: function(unit) {
      return ' <span class="matcha-per"><span>per </span></span>' + unit;
    },

    renderPlans: function() {
      const size = this.currentSize;

      // each plan's own figures
      this.options.forEach(opt => {
        const data = this.parse(opt)[size] || {};
        const flights = parseInt(opt.dataset.flights || '1', 10);
        const badge = opt.querySelector('[data-savings-badge]');
        const per = opt.querySelector('[data-per]');
        const perFlight = opt.querySelector('[data-per-flight]');
        const perTin = opt.querySelector('[data-per-tin]');

        if (badge) {
          // Tier cards read "SAVE $30". A plan row adds the gift only while collapsed —
          // once open, the gift is spelled out in the callout, so the badge is just the
          // saving. Matches the wireframe in both states.
          const isTier = opt.classList.contains('matcha-tier');
          const radio = opt.querySelector('.matcha-radio');
          const open = !isTier && !!(radio && radio.checked);
          const gift = (!isTier && !open && opt.dataset.giftVariant) ? ' + a free gift' : '';
          if (data.savings) { badge.innerHTML = this.badgeHtml('Save ' + data.savings, gift); badge.hidden = false; }
          else { badge.hidden = true; }
        }
        if (per) per.innerHTML = this.perTin(data, flights);
        if (perFlight) perFlight.innerHTML = data.perflight ? data.perflight + this.per('flight') : '';
        if (perTin) perTin.innerHTML = this.perTin(data, flights);

        const list = opt.querySelector('[data-benefits]');
        if (list) list.innerHTML = this.benefits(opt, data, flights);
      });

      this.renderPrepayHead();
      this.syncOpenState();
    },

    benefits: function(opt, data, flights) {
      const rows = [];
      const giftCount = flights > 1 ? 2 : 1;
      if (opt.dataset.giftVariant) {
        rows.push(giftCount > 1 ? giftCount + ' FREE gifts with your first flight' : 'FREE gift with your first flight');
      }
      if (data.savings) rows.push('Save ' + data.savings + ' and FREE shipping');
      rows.push(flights > 1
        ? 'Billed every ' + (flights * 3) + ' months, ships every 3 months'
        : 'Billed and ships every 3 months, skip or cancel anytime');
      return rows.map(r => '<li>' + r + '</li>').join('');
    },

    renderPrepayHead: function() {
      const row = document.querySelector('.matcha-plan--prepay');
      if (!row) return;
      const tiers = this.tierOptions();
      if (!tiers.length) return;
      const checked = tiers.find(o => { const r = o.querySelector('.matcha-radio'); return r && r.checked; });
      const open = !!checked;

      // closed: advertise the best deal. open: show the chosen tier.
      let show = checked;
      if (!show) {
        show = tiers.reduce((best, o) => {
          const a = this.parse(o)[this.currentSize] || {};
          const b = this.parse(best)[this.currentSize] || {};
          const av = parseFloat(String(a.perflight || '').replace(/[^0-9.]/g, '')) || Infinity;
          const bv = parseFloat(String(b.perflight || '').replace(/[^0-9.]/g, '')) || Infinity;
          return av < bv ? o : best;
        }, tiers[0]);
      }

      const data = this.parse(show)[this.currentSize] || {};
      const flights = parseInt(show.dataset.flights || '2', 10);
      const titleEl = row.querySelector('.matcha-plan__title');
      const badgeEl = row.querySelector('[data-prepay-badge]');
      const fromEl = row.querySelector('[data-prepay-from]');
      const priceEl = row.querySelector('.matcha-plan__price [data-price]');
      const compareEl = row.querySelector('.matcha-plan__price [data-compare]');
      // data-per lives in the aside, not inside the price element
      const perEl = row.querySelector('.matcha-plan__aside [data-per]');

      if (titleEl) titleEl.textContent = open ? 'Prepay for ' + flights + ' flights' : 'Prepay';
      if (fromEl) fromEl.hidden = open;
      // closed, "as low as" is a PER FLIGHT figure, not the tier total
      if (priceEl) priceEl.textContent = (open ? data.price : data.perflight) || '';
      if (compareEl) {
        if (open && data.compare) { compareEl.textContent = data.compare; compareEl.hidden = false; }
        else { compareEl.hidden = true; }
      }
      // open, per tin for the chosen tier; closed, just the unit, since each tier card
      // shows its own per tin once the row opens
      if (perEl) {
        if (open) perEl.innerHTML = this.perTin(data, flights);
        else perEl.textContent = data.perflight ? 'per flight' : '';
      }

      // the prepay body's benefits live on the row, not on an option, so the per-option
      // pass in renderPlans never reaches them — fill them from the chosen tier here
      const bodyList = row.querySelector('.matcha-plan__body > [data-benefits]');
      if (bodyList) bodyList.innerHTML = open ? this.benefits(show, data, flights) : '';
      if (badgeEl) {
        if (open) { badgeEl.hidden = true; }
        else {
          // best saving across the tiers, which is what "up to" means
          let best = '';
          let bestN = 0;
          tiers.forEach(o => {
            const d = this.parse(o)[this.currentSize] || {};
            const n = parseFloat(String(d.savings || '').replace(/[^0-9.]/g, '')) || 0;
            if (n > bestN) { bestN = n; best = d.savings; }
          });
          // the gift suffix only when a prepay gift is actually configured, so the
          // whole promo switches off by clearing the gift settings
          const hasGift = tiers.some(o => o.dataset.giftVariant);
          const suffix = hasGift ? ' + 2 free gifts' : '';
          badgeEl.innerHTML = best ? this.badgeHtml('Save up to ' + best, suffix) : '';
          badgeEl.hidden = !best;
        }
      }
      row.classList.toggle('is-open', open);
    },

    syncOpenState: function() {
      this.options.forEach(opt => {
        if (opt.classList.contains('matcha-tier')) return;
        const r = opt.querySelector('.matcha-radio');
        opt.classList.toggle('is-open', !!(r && r.checked));
      });
    },

    updateBackInStock: function() {
      const el = this.backInStock;
      if (!el) return;
      const btn = this.sizeButtons.find(b => b.dataset.size === this.currentSize);
      const soldout = !!(btn && btn.dataset.soldout === 'true');
      const headingEl = el.querySelector('.back-in-stock__heading-text');
      if (headingEl) headingEl.textContent = '3 tins × ' + this.currentSize + ' is sold out';
      const vid = btn && btn.dataset.variantId;
      if (vid) {
        el.dataset.variantId = vid;
        if (btn.dataset.variantTitle) el.dataset.variantTitle = btn.dataset.variantTitle;
        if (typeof el.variantId !== 'undefined') el.variantId = vid;
      }
      if (typeof el.show === 'function' && typeof el.hide === 'function') {
        if (soldout) { el.show(); } else { el.hide(); }
        if (typeof el.resetForm === 'function') el.resetForm();
      } else {
        el.classList.toggle('hidden', !soldout);
      }
    },

    selectedOption: function() {
      const radio = document.querySelector('input[name="matcha_purchase"]:checked');
      return radio ? radio.closest('.matcha-option') : null;
    },

    updateAtcPrice: function() {
      const opt = this.selectedOption();
      if (!opt) return;
      const data = this.parse(opt)[this.currentSize] || {};

      // the button is a plain label — the plan rows carry the price and savings
      this.syncMainPrice(data);

      // disable the add-to-cart button when the selected size is sold out
      const sizeBtn = this.sizeButtons.find(b => b.dataset.size === this.currentSize);
      const soldout = !!(sizeBtn && sizeBtn.dataset.soldout === 'true');
      const atc = document.getElementById('matchaAddToCart');
      if (atc) {
        atc.disabled = soldout;
        atc.classList.toggle('is-soldout', soldout);
        if (soldout) atc.textContent = 'Sold out';
        else atc.textContent = 'Add to Cart';
      }

      const wrapper = document.querySelector('.matcha-subscription-wrapper');
      if (wrapper) wrapper.classList.toggle('size-soldout', soldout);
      this.options.forEach(o => {
        const radio = o.querySelector('input[name="matcha_purchase"]');
        if (radio) radio.disabled = soldout;
      });
      // only show the ship-by bar when the selected size is actually purchasable
      const purchasable = !!(sizeBtn && sizeBtn.dataset.purchasable === 'true');
      const shipBy = document.getElementById('matchaShipBy');
      if (shipBy && this._shipByReady) shipBy.classList.toggle('mtf-soldout-hide', !purchasable);
      // refresh the bar text so pre-order sizes show the restock date immediately
      if (this._renderShipBy) this._renderShipBy();
      const trust = document.querySelector('.matcha-trust');
      if (trust) trust.classList.toggle('mtf-soldout-hide', soldout);
    },

    getSelectedData: function() {
      const opt = this.selectedOption();
      if (!opt) return {};
      return this.parse(opt)[this.currentSize] || {};
    },

    // The theme (theme.js updateVariantDeterminedVisibilityAreas) rebuilds the
    // .price-area from the current *variant* on init/variant change, which would
    // wipe our selection's price. Watch for that and re-assert. Observer callbacks
    // run before paint, so the theme's variant price never actually renders.
    observeMainPrice: function() {
      const container = document.querySelector('.price-container');
      if (!container || typeof MutationObserver === 'undefined') return;
      const self = this;
      this._priceObserver = new MutationObserver(function() {
        self.syncMainPrice(self.getSelectedData());
      });
      this._priceObserver.observe(container, { childList: true, subtree: true });
    },

    // Mirror the selected tier/size price onto the theme's main product price
    // block (.price-container) so the headline price matches the selector.
    syncMainPrice: function(data) {
      const price = (data && data.price) || '';
      const compare = (data && data.compare) || '';
      if (!price) return;
      if (this._priceObserver) this._priceObserver.disconnect();
      document.querySelectorAll('.price-container .price').forEach(function(block) {
        const currentEl = block.querySelector('.current-price');
        if (currentEl) currentEl.textContent = price;
        let wasEl = block.querySelector('.was-price');
        if (compare) {
          if (!wasEl && currentEl) {
            wasEl = document.createElement('span');
            wasEl.className = 'was-price theme-money';
          }
          // struck price reads before the current one: "$120.00  $110 CAD".
          // insertAdjacentElement moves an existing node, so this also corrects
          // one the theme rendered in the other order.
          if (wasEl && currentEl) currentEl.insertAdjacentElement('beforebegin', wasEl);
          if (wasEl) { wasEl.textContent = compare; wasEl.hidden = false; wasEl.style.display = ''; }
          block.classList.add('on-sale');
        } else if (wasEl) {
          wasEl.hidden = true;
          wasEl.style.display = 'none';
          block.classList.remove('on-sale');
        } else {
          block.classList.remove('on-sale');
        }
      });
      const c = document.querySelector('.price-container');
      if (this._priceObserver && c) {
        this._priceObserver.observe(c, { childList: true, subtree: true });
      }
    },

    handleAddToCart: function(e) {
      e.preventDefault();
      if (this.isProcessing) return;

      const opt = this.selectedOption();
      if (!opt) return;
      const data = this.parse(opt)[this.currentSize];
      if (!data || !data.id) return; // no variant for this size/tier
      const curBtn = this.sizeButtons.find(b => b.dataset.size === this.currentSize);
      if (curBtn && curBtn.dataset.soldout === 'true') return; // size sold out

      const button = e.currentTarget;
      const originalHTML = button.innerHTML;
      this.isProcessing = true;
      button.disabled = true;

      const productData = { id: data.id, quantity: 1 };
      const plan = opt.dataset.sellingPlan;
      if (plan) productData.selling_plan = plan;

      // the gift goes in at full price; a Shopify automatic discount zeroes it
      const items = [productData];
      const giftVariant = parseInt(opt.dataset.giftVariant, 10);
      if (plan && giftVariant) {
        items.push({
          id: giftVariant,
          quantity: 1,
          // read by mtf-gift-guard.js to drop the gift if this plan leaves the cart
          properties: { _mtf_gift: opt.dataset.parentHandle || '' }
        });
      }

      // an atomic add fails whole if the gift is unavailable, which would take
      // the buy button down with it
      this.addToCart({ items: items })
        .catch((error) => {
          if (items.length < 2) throw error;
          return this.addToCart({ items: [productData] });
        })
        .then(() => {
          button.textContent = 'Added';
          this.refreshCart();
          setTimeout(() => this.openCartDrawer(), 200);
          setTimeout(() => {
            button.disabled = false;
            button.innerHTML = originalHTML;
            this.updateAtcPrice();
            this.isProcessing = false;
          }, 1500);
        })
        .catch(() => {
          button.disabled = false;
          button.innerHTML = originalHTML;
          this.updateAtcPrice();
          this.isProcessing = false;
        });
    },

    addToCart: function(data) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      }).then(r => { if (!r.ok) throw new Error('add failed'); return r.json(); });
    },

    refreshCart: async function() {
      try {
        const cartForm = document.querySelector('cart-form[data-ajax-update="true"]');
        if (cartForm) cartForm.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false }));
        const cartData = await fetch('/cart.js').then(r => r.json());
        document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true, detail: cartData }));
      } catch (error) { console.error('Cart refresh error:', error); }
    },

    openCartDrawer: function() {
      const selectors = ['.header-cart','.cart-link','.header-cart-icon','.cart-icon','[data-cart-toggle]','.cart-count','a[href*="/cart"]'];
      const cartButton = selectors.reduce((found, sel) => found || document.querySelector(sel), null);
      if (cartButton) { cartButton.click(); }
      else { document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { detail: { opener: true } })); }
      setTimeout(() => this.updateProgressBar(), 500);
    },

    updateProgressBar: function() {
      if (typeof window.updateProgress === 'function') window.updateProgress();
      fetch('/cart.js').then(r => r.json()).then(cart => {
        const cartTotal = cart.total_price / 100;
        const threshold = FREE_SHIPPING_THRESHOLDS[cart.currency];
        if (!threshold) return;
        let progress = Math.min((cartTotal / threshold) * 100, 100);
        const hasSubscription = cart.items.some(item => {
          const title = item.title.toLowerCase();
          return title.includes('gift subscription') ||
                (title.includes('issue') && title.includes('the roasters pack')) ||
                title.includes('matcha subscription') ||
                title.includes('advent calendar');
        });
        if (hasSubscription) progress = 100;
        const progressBar = document.getElementById('progress-bar-price');
        if (progressBar) progressBar.style.width = progress + '%';
        this.updateProgressMessage(cartTotal, hasSubscription, threshold);
      }).catch(error => console.error('Progress bar error:', error));
    },

    updateProgressMessage: function(cartTotal, hasSubscription, threshold) {
      const message = document.getElementById('progress-message');
      const secondMessage = document.getElementById('progress-second-message');
      const continueLink = document.getElementById('progress-continue');
      if (!message) return;
      if (cartTotal < threshold && !hasSubscription) {
        const remaining = (threshold - cartTotal).toFixed(2);
        message.innerHTML = `You're only <span>$${remaining}</span> away from <span class='free-shipping'>FREE SHIPPING</span>`;
        if (secondMessage) secondMessage.innerHTML = "&nbsp;(or, free shipping with every subscription or gift order)";
        if (continueLink) continueLink.innerHTML = "<a class='progress-continue-shopping' href='https://theroasterspack.com/collections/buy-canadian-coffee'>Continue shopping</a>";
      } else {
        message.innerHTML = "🎉 You've unlocked <span class='free-shipping'>FREE SHIPPING</span>";
        if (secondMessage) secondMessage.innerHTML = "";
        if (continueLink) continueLink.innerHTML = "";
      }
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => CartHandler.init());
  } else {
    CartHandler.init();
  }
})();
